import {
  Box,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Heading,
  HStack,
  SimpleGrid,
} from "@chakra-ui/react";
import { HiOutlinePlus, HiOutlineTrash } from "react-icons/hi";
import CodesetSelect from "../../CodesetSelect";
import UuidPreview from "../../UuidPreview";
import PartySelectById from "../../PartySelectById";
import { createEmptyContractParty } from "../../utils/placementDefaults";

const ContractPartyEditor = ({ party, partyIndex, onUpdate, onRemove }) => {
  const updateField = (field, value) => {
    onUpdate(partyIndex, field, value);
  };

  return (
    <Box borderWidth="1px" borderRadius="md" p={4} mb={6} borderColor="gray.500">
      <UuidPreview uuid={party.id} />

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} mb={4}>
        <PartySelectById
          label="Party Reference"
          value={party.partyReference}
          onChange={(value) => updateField("partyReference", value)}
        />

        <CodesetSelect
          label="Role"
          codesetCode="7502"
          value={party.role ? { code: party.role, description: "" } : null}
          onChange={(value) => updateField("role", value.code)}
        />
      </SimpleGrid>

      <FormControl mb={4}>
        <FormLabel>Role Description</FormLabel>
        <Input
          value={party.roleDescription || ""}
          onChange={(e) => updateField("roleDescription", e.target.value)}
        />
      </FormControl>

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} mb={4}>
        <FormControl>
          <FormLabel>Effective Date/Time</FormLabel>
          <Input
            type="datetime-local"
            value={party.effectiveDateTime?.value || ""}
            onChange={(e) =>
              updateField("effectiveDateTime", {
                ...party.effectiveDateTime,
                value: e.target.value,
              })
            }
          />
        </FormControl>

        <FormControl>
          <FormLabel>Expiration Date/Time</FormLabel>
          <Input
            type="datetime-local"
            value={party.expirationDateTime?.value || ""}
            onChange={(e) =>
              updateField("expirationDateTime", {
                ...party.expirationDateTime,
                value: e.target.value,
              })
            }
          />
        </FormControl>
      </SimpleGrid>

      <HStack justify="flex-end" mt={4}>
        <IconButton
          size="md"
          icon={<HiOutlineTrash />}
          aria-label="Delete Contract Party"
          onClick={() => onRemove(partyIndex)}
        />
      </HStack>
    </Box>
  );
};

const ContractPartiesEditor = ({ contractParties = [], onChange }) => {
  const updateParty = (partyIndex, field, value) => {
    const updated = [...contractParties];
    updated[partyIndex] = {
      ...updated[partyIndex],
      [field]: value,
    };
    onChange(updated);
  };

  const addParty = () => {
    onChange([...contractParties, createEmptyContractParty()]);
  };

  const removeParty = (partyIndex) => {
    const updated = [...contractParties];
    updated.splice(partyIndex, 1);
    onChange(updated);
  };

  return (
    <Box>
      <HStack alignItems="center" mb={4}>
        <Heading size="md">Contract Parties</Heading>
        <IconButton
          icon={<HiOutlinePlus />}
          size="md"
          aria-label="Add Contract Party"
          onClick={addParty}
        />
      </HStack>

      {contractParties.map((party, partyIndex) => (
        <ContractPartyEditor
          key={party.id}
          party={party}
          partyIndex={partyIndex}
          onUpdate={updateParty}
          onRemove={removeParty}
        />
      ))}
    </Box>
  );
};

export default ContractPartiesEditor;
